import React from 'react';
import {
  CContainer, CRow, CCol, CCard, CCardHeader, CCardBody,
  CBreadcrumb, CBreadcrumbItem
} from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import CurrencyInputs from '../../components/CurrencyInputs/CurrencyInputs';
import { connect } from 'react-redux';
import { createCurrencyRequestAction } from '../../store/currency/currencyActions';

const CreateCurrency = ({ createCurrencyRequest, isLoading, createCurrencyData }) => {
  const navigate = useNavigate();

  const handleSubmit = (data) => {
    createCurrencyRequest({ data, navigate });
  };

  const handleCancel = () => {
    navigate('/currency');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/currency" onClick={(e) => { e.preventDefault(); handleCancel(); }}>
          Currency
        </CBreadcrumbItem>
        <CBreadcrumbItem active>Create</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>Create Currency</h4></CCardHeader>
            <CCardBody>
              <CurrencyInputs
                onSubmit={handleSubmit}
                onCancel={handleCancel}
                isLoading={isLoading}
                submitResponse={createCurrencyData}
              />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading,
  createCurrencyData: state.currencyReducer.createCurrencyData,
});

const mapDispatchToProps = {
  createCurrencyRequest: createCurrencyRequestAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateCurrency);
